module.exports = __webpack_public_path__ + "img/tree&bbl3.800216b8.png";